const KEY = "kb_historial";
const MAX = 10;

export const HistorialService = {
  get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  },

  add(art) {
    const historial = this.get().filter(h => h.id !== art.id);
    historial.unshift({
      id: art.id,
      titulo: art.titulo,
      tipo: art.tipo,
      categoriaId: art.categoriaId,
      fechaVisita: new Date().toISOString(),
    });
    localStorage.setItem(KEY, JSON.stringify(historial.slice(0, MAX)));
  },

  clear() {
    localStorage.removeItem(KEY);
  },
};
